import React, {Component} from 'react';
import { Redirect, Route } from "react-router";

import { connect } from 'react-redux';
import { Router, Switch } from 'react-router-dom';

import { history } from '../../helpers';
import { alertActions } from '../../modules/alert';
import { userinfoActions } from '../../modules/userinfo';
import { codemngActions } from '../../modules/codemng';

import AppShell from './AppShell';
import AuthRoute from './AuthRoute';
import Home from './Home';
import PortalAccess from './PortalAccess';
import Dashboard from '../Dashboard/Dashboard';
import CodeMng from '../CodeMng/CodeMng';
import BoardInfoMng from '../BoardInfo/BoardInfoMng';
import LoginPage from '../LoginPage/LoginPage';
import ContentsAllMng from '../ContentsMng/ContentsAllMng';
import ContentsMng from '../ContentsMng/ContentsMng';
import ContentsAdd from '../ContentsMng/ContentsAdd';
import ContentsMod from '../ContentsMng/ContentsMod';
import NoticeMng from '../ContentsMng/NoticeMng';
import NoticeAdd from '../ContentsMng/NoticeAdd';
import NoticeMod from '../ContentsMng/NoticeMod';
import OpbMng from '../OpbMng/OpbMng';
import FirmwareMng from '../FirmwareMng/FirmwareMng';
import FirmwareAdd from '../FirmwareMng/FirmwareAdd';
import FirmwareMod from '../FirmwareMng/FirmwareMod';
import FirmwareMngDerv from '../FirmwareMng/FirmwareMngDerv';
import OpbState from '../OpbState/OpbState';
import ScreenMod from '../OpbState/ScreenMod';
import TemplateMng from '../TemplateMng/TemplateMng';
import TemplateAdd from '../TemplateMng/TemplateAdd';
import TemplateMod from '../TemplateMng/TemplateMod';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            redirectUrl: '',
            pathName: '',
            routes: [
                {path: '/home', pathName: null, type: 'guest', component: Home, props:{}},
                {path: '/portalaccess', pathName: null, type: 'guest', component: PortalAccess, props:{}},
                {path: '/dashboard', pathName: null, type: 'private', component: Dashboard, props:{}},
                {path: '/login', pathName: null, type: 'guest', component: LoginPage, props:{}},
                {path: '/logout', pathName: null, type: 'private', component: LoginPage, props:{}},
                {path: '/opbmng', pathName: ['Display관리'], type: 'private', component: OpbMng, props:{}},
                {path: '/firmwareMng', pathName: ['즉시패치관리'], type: 'private', component: FirmwareMng, props:{}},
                {path: '/firmwareAdd', pathName: ['즉시패치관리','패치등록'], type: 'private', component: FirmwareAdd, props:{}},
                {path: '/firmwareMod', pathName: ['즉시패치관리','패치수정'], type: 'private', component: FirmwareMod, props:{}},
                {path: '/firmwareMngDerv', pathName: ['예약패치관리'], type: 'private', component: FirmwareMngDerv, props:{}},
                {path: '/contentsAllMng', pathName: ['컨텐츠관리','현장컨텐츠관리'], type: 'private', component: ContentsAllMng, props:{}},
                {path: '/contentsMng', pathName: ['컨텐츠관리','통합컨텐츠관리'], type: 'private', component: ContentsMng, props:{}},
                {path: '/contentsAdd', pathName: ['컨텐츠관리','통합컨텐츠등록'], type: 'private', component: ContentsAdd, props:{}},
                {path: '/contentsMod', pathName: ['컨텐츠관리','통합컨텐츠수정'], type: 'private', component: ContentsMod, props:{}},
                {path: '/noticeMng', pathName: ['컨텐츠관리','공지사항관리'], type: 'private', component: NoticeMng, props:{}},
                {path: '/noticeAdd', pathName: ['컨텐츠관리','공지사항등록'], type: 'private', component: NoticeAdd, props:{}},
                {path: '/noticeMod', pathName: ['컨텐츠관리','공지사항수정'], type: 'private', component: NoticeMod, props:{}},
                {path: '/templateMng', pathName: ['컨텐츠관리','템플릿등록관리'], type: 'private', component: TemplateMng, props:{}},
                {path: '/templateAdd', pathName: ['컨텐츠관리','템플릿등록'], type: 'private', component: TemplateAdd, props:{}},
                {path: '/templateMod', pathName: ['컨텐츠관리','템플릿수정'], type: 'private', component: TemplateMod, props:{}},
                {path: '/codemng', pathName: ['코드관리'], type: 'private', component: CodeMng, props:{}},
                {path: '/boardinfo', pathName: ['통합게시판관리'], type: 'private', component: BoardInfoMng, props:{}},
                {path: '/opbstate', pathName: ['Display관리','Display현황'], type: 'private', component: OpbState, props:{}},
                {path: '/screenMod', pathName: ['Display관리','Display화면편집'], type: 'private', component: ScreenMod, props:{}},
            ]
        }

        history.listen((location, action) => {
            // clear alert on location change
            this.stateRefresh();
        });

        if(props.user){
            props.storeCodes();

            if(!props.myInfo)
                props.getUserinfo();
        }
    }

    stateRefresh = () => {
        this.setState({
            redirect: this.props.alert && this.props.alert.redirectUrl ? true : false,
            redirectUrl : this.props.alert && this.props.alert.redirectUrl ? this.props.alert.redirectUrl : ''
        });

        this.setPathName();
        this.props.clearAlerts();
    }

    componentDidMount = () => {
        this.setPathName();
    }

    setPathName = () => {
        let arrPath = document.location.href.split('/');
        let arrRoute = this.state.routes.filter((route) => route.path==='/'+arrPath[arrPath.length-1]);
        if(arrRoute!==undefined && arrRoute.length > 0){
            this.setState({
                pathName: arrRoute[0].pathName
            })
        }
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }

    render (){
        let authRoutes = [];
        this.state.routes.map((route, i) => {
            return authRoutes.push(<AuthRoute key={i} path={route.path} type={route.type} component={route.component}/>);
        })

        return (
            <Router history={history}>
                {this.state.redirect && 
                    <Redirect to={this.state.redirectUrl} />
                }
                <AppShell stateRefresh={this.stateRefresh} pathName={this.state.pathName}>
                    <Switch>
                        <Route exact path="/" component={Home}/>
                        {authRoutes}
                    </Switch>
                </AppShell>
            </Router>
        );
    }
}

function mapState(state) {
    const { authentication, alert, userinfo } = state;
    const { user } = authentication;
    const myInfo = userinfo.item;
    return { alert, user, myInfo };
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    getUserinfo: userinfoActions.getUserinfo,
    storeCodes: codemngActions.storeCodes,
};

export default connect(mapState, actionCreators)(App);